import { supabase } from '../lib/supabase';
import { useEffect, useState } from 'react';

export default function OrganizationPage() {
  const [orgs, setOrgs] = useState<any[]>([]);

  useEffect(() => {
    supabase.from('organizations').select('*').then(({ data }) => {
      if (data) setOrgs(data);
    });
  }, []);

  const createOrg = async () => {
    const name = prompt('Nome da organização:');
    if (!name) return;
    const slug = name.toLowerCase().replace(/\s+/g, '-');
    await supabase.from('organizations').insert({ name, slug });
    supabase.from('organizations').select('*').then(({ data }) => {
      if (data) setOrgs(data);
    });
  };

  return (
    <div style={{ maxWidth: 700, margin: '0 auto', padding: 32 }}>
      <h1 style={{ marginBottom: 24 }}>Organização</h1>
      <button onClick={createOrg} style={{ padding: '10px 20px', background: 'var(--color-primary)', color: '#fff', border: 'none', borderRadius: 'var(--radius)', marginBottom: 24 }}>
        Criar Organização
      </button>
      {orgs.map((org) => (
        <div key={org.id} style={{ padding: 16, background: 'var(--color-surface)', borderRadius: 'var(--radius)', marginBottom: 8, border: '1px solid var(--color-border)' }}>
          <strong>{org.name}</strong> <span style={{ color: 'var(--color-text-muted)', fontSize: 13 }}>{org.slug}</span>
        </div>
      ))}
    </div>
  );
}